// extracted by mini-css-extract-plugin
export default {"headerTitle":"reviews_headerTitle__-21J3","page":"reviews_page__3Fi-T","header":"reviews_header__NCJlN"};